import React from "react";
import { useTranslation } from "react-i18next";

import {
  Button,
  Image,
} from '@lockerpm/design';

import authComponents from "./components";
import itemsComponents from "../../components/items";

import images from "../../assets/images";

import { openNewTab } from "../../utils/common";
import global from "../../config/global";
import authServices from "../../services/auth";

const Setup2FA = () => {
  const { AuthCard } = authComponents;
  const { UserInfo } = itemsComponents;
  const { Block2FAImg } = images;

  const { t } = useTranslation();

  return (
    <div
      className={`setup-2fa auth-page`}
    >
      <AuthCard
        className="w-[600px]"
        other={
          <div className="mt-4 text-center">
            <span>
              {t('setup_2fa.note')}
              <Button
                type="link"
                className="font-semibold"
                onClick={() => authServices.logout(true)}
              >
                {t('button.logout')}
              </Button>
            </span>
          </div>
        }
      >
        <>
          <div className="text-center">
            <p className="text-2xl font-semibold">
              { t('setup_2fa.title') }
            </p>
            <p className="mt-2 text-center">
              { t('setup_2fa.description') }
            </p>
            <div className="flex items-center justify-center my-6">
              <UserInfo />
            </div>
            <Image
              style={{ width: '100%' }}
              src={Block2FAImg}
              preview={false}
            />
          </div>
          <Button
            className="w-full mt-4"
            size="large"
            type="primary"
            onClick={() => openNewTab(`${global.urls.LOCKER_ID_URL}/security/two-step-verification`)}
          >
            {t('setup_2fa.button')}
          </Button>
        </>
      </AuthCard>
    </div>
  );
}

export default Setup2FA;